import React, { useState, useEffect, Fragment } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import CreateIcon from '@mui/icons-material/Create';
import { Tooltip } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ReactDOM from 'react-dom';
import Button from '@mui/material/Button';
import BillPrint from '../Sale/Saleprint';
import { fetchData, fetchEngineerStockDetails } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import PrintIcon from '@mui/icons-material/Print';
import InfoIcon from '@mui/icons-material/Info';

function SaleIndex() {
    const history = useHistory();
    const { isAuthenticated, companyId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


    const [data, setData] = useState([]);
    const [customerId, setCustomerID] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [contactNumber, setContactNumber] = useState('');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState('');

    const fetchCustomers = async () => {
        try {
            const response = await fetchData('CustomerApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setCustomers(response.response_data);
                const options = response.response_data.map(customer => ({
                    value: customer.customerName,
                    label: customer.customerName
                }));
                setCustomerOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Customer Types:', error);
        }
    };

    const handleCustomerChange = (selectedOption) => {
        setSelectedCustomer(selectedOption);
        const selectedCustomerData = customers.find(customer => customer.customerName === selectedOption.label);
        if (selectedCustomerData) {
            setContactNumber(selectedCustomerData.contactNumber1);
            setCustomerID(selectedCustomerData.id);
        } else {
            setContactNumber('');
            setSelectedCustomer('');
            setCustomers([]);
        }
    };

    useEffect(() => {
        fetchCustomers();
    }, []);

    const handleRefresh = async () => {
        try {
            const response = await fetchEngineerStockDetails('SaleApi', companyId, customerId, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
                console.log(response);
            } else {
                const responses = await fetchEngineerStockDetails('SaleApi', companyId, customerId, token);
                if (responses.responseCode === '1111') {
                    setData(responses.response_data);
                    console.log(responses);
                }
            }
        } catch (error) {
            console.error('Error occurred while fetching data:', error);
        }
    };


    const handlePrint = async (saleid) => {
        try {

            const response = await fetchData('SaleDetailsApi', `/SalePrint/${saleid}`, token);
            const labelData = response.response_data;

            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            iframe.contentWindow.print();

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">

            <div className='w-full mb-2 flex items-center'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>Sale</h6>
            </div>

            <div className="table-container">
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#090040' }}> {/* Set background color */}
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', width: '20px', color: 'white', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Customer</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Bill Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Bill No</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Amount</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((item, index) => (
                                <TableRow key={item.id} className={item.isActive ? '' : 'inactiveRow'}>
                                    <TableCell style={{ fontSize: '15px', padding: '5px' }}>{index + 1}</TableCell>
                                    <TableCell style={{ fontSize: '15px', padding: '5px' }}>{item.customer}</TableCell>
                                    <TableCell style={{ fontSize: '15px', padding: '5px' }}>{formatDate(item.invoiceDate)}</TableCell>
                                    <TableCell style={{ fontSize: '15px', padding: '5px' }}>{item.invoiceNo}</TableCell>
                                    <TableCell style={{ fontSize: '15px', padding: '5px' }}>{item.totalAmount}</TableCell>
                                    <TableCell style={{ fontSize: '15px', padding: '5px' }}>
                                        <Link to={`/SaleDetail/${item.saleId}`}>
                                            <Tooltip title="Info">
                                                <IconButton>
                                                    <InfoIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Link>
                                        <Link to={`/SaleEdit/${item.saleId}`}>
                                            <Tooltip title="Edit">
                                                <IconButton>
                                                    <CreateIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Link>
                                        <Tooltip title="Print">
                                            <IconButton onClick={() => handlePrint(item.saleId)}>
                                                <PrintIcon />
                                            </IconButton>

                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div >
        </div >
    );

}

export default SaleIndex;


